import { FC, useEffect, useState } from 'react';
import { Input, InputProps } from '@chakra-ui/react';
import Autocomplete from 'react-google-autocomplete';
import { useFormContext, useWatch } from 'react-hook-form';
import { Country, DonationField } from '../../constants';

export type Address = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
};

// TODO
// A temporary test  key for google maps. This needs to be accessed via CyberArk and via a different key.
const key = 'AIzaSyBARA0XDUhZutpuJajFgnoyfVeGM3DrlL4';

const formatGooglePlaceResults = (data: any) =>
  data?.reduce(
    (obj: any, item: any) => ({
      ...obj,
      [item.types[0]]: item,
    }),
    {}
  );

const parseAddressField = (place: any, field: string): string => {
  if (!place?.address_components?.length) return '';

  const components = formatGooglePlaceResults(place?.address_components);

  const compType = components[field] ? components[field] : null;

  const val: string =
    field === 'country' ? compType?.long_name : compType?.short_name;

  return val || '';
};

const parseAddress = (place: any): Address => {
  console.log({ place });
  const address1 = `${parseAddressField(
    place,
    'street_number'
  )} ${parseAddressField(place, 'route')}`;
  const address2 = parseAddressField(place, 'neighborhood');
  const country = parseAddressField(place, 'country');
  const postCode = parseAddressField(place, 'postal_code');
  const state = parseAddressField(place, 'administrative_area_level_1');
  const city = parseAddressField(place, 'locality');

  return {
    address1,
    address2,
    city,
    state,
    postCode,
    country,
  };
};

export interface AddressAutoCompleteProps extends InputProps {
  onBlur: (a: any) => void;
  onAddressSelected: (address: Address) => void;
}

export const AddressAutoComplete: FC<AddressAutoCompleteProps> = ({
  onAddressSelected,
  onBlur,
  ...field
}): JSX.Element => {
  const [countryRestriction, setCountryRestriction] = useState<string>('us');

  const { getValues } = useFormContext();

  const options = {
    fields: ['formatted_address', 'geometry', 'name', 'address_components'],
    strictBounds: false,
    types: ['address'],
    componentRestrictions: { country: countryRestriction },
  };

  const countryWatch = useWatch({ name: DonationField.country });

  useEffect(() => {
    if (countryWatch === Country.UnitedStates) {
      setCountryRestriction('us');
    } else if (countryWatch === Country.Canada) {
      setCountryRestriction('ca');
    }
  }, [countryWatch, getValues, setCountryRestriction]);

  return (
    <Input
      {...field}
      aria-label={field.name}
      as={Autocomplete}
      maxLength={60}
      options={options}
      apiKey={key}
      onPlaceSelected={(place: any) => {
        const parsedAddress = parseAddress(place);
        onAddressSelected(parsedAddress);
      }}
      onBlurCapture={onBlur}
    />
  );
};
